<mat-form-field focused class="nv-mat-form-field">
  <mat-label>{{label}}</mat-label>
  <mat-select  [value]="selection" matNativeControl (selectionChange)="onSelectionChange($event)">
    <mat-option  class="nv-mat-option"
      *ngFor="let option of options" 
      [value]="option.key"
    >{{ option.human }}</mat-option>
  </mat-select>
</mat-form-field>